export const methodSupportsBody = (method: string) => {
  return !['get', 'head'].includes(method.toLowerCase());
};
